//BlockRows.js
import React, { useState, useEffect } from 'react';
import "../../Assets/Styles/Form.css";
import Axios from 'axios';
import * as FaIcons from "react-icons/fa";
import { hasJWTToken } from "../Account/RouteGuard";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import AxiosInstance from '../Axios/AxiosInstance';
export const BlockRows = () => {
    const _userID = sessionStorage.getItem("user_id");
    var plantID = sessionStorage.getItem("user_plantid");
    const role_id = sessionStorage.getItem("role_id");
    let _token = sessionStorage.getItem("token");
    if (_token) _token = "Token exists";
    let [responseData, setResponseData] = useState([]);
    const [plantOption, setPlantOption] = useState([]);
    const [blockOption, setBlockOption] = useState([]);
    const [rowOption, setRowOption] = useState([]);
    const [plantSelectedOption, setPlantSelectedOption] = useState(null);
    let [formData, setFormData] = useState({
        block_row_id: null,
        plant_id: null,
        block_id: null,
        row_id: null,
        user_id: _userID,
        jwt_token: _token,
        block_row_mode: 'Insert',
        message: '',
    });
    const [errors, setErrors] = useState({});
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        var newErrors = validateForm(formData);
        alert(newErrors);
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            formData.block_row_mode = "Insert";
            formData.user_id = 1;
            let objBlockRowData = AxiosInstance.post("/PlantBlockRows", formData)
            formData.block_id = null;
            formData.row_id = null;
            //formData.block_id = null;
            //formData.block_name = '';
            formData.message = "Added new block row successfully!";
            console.log('Form submitted successfully!');
        } else {
            formData.message = 'Block Row submission failed due to validation errors.'
            console.log('Form submission failed due to validation errors.');
        }
    };
    const validateForm = (data) => {
        const errors = {};
        alert(data.plant_id);
        alert(data.block_id);
        alert(data.row_id);
        if (data.plant_id === null || data.plant_id.length === 0) {
            errors.plant_id = 'Plant ID is required';
            alert(errors.plant_id);
            //alert(errors.message);
        } else if (data.plant_id.length > 10) {
            // errors.plant_id = 'Plant ID should not be less than or more than 10 digits';
        }

        if (data.block_id === 0 || data.block_id === null) {
            errors.block_id = 'Block ID is required';
            alert(errors.block_id)
        } else if (data.block_id.length > 10) {
            // errors.block_id = 'Block ID should not be less than or more than 10 digits';
        }

        if (data.row_id === null || data.row_id === 0) {
            errors.row_id = 'Block Row ID is required';
            alert(errors.row_id)
        } else if (data.row_id.length > 10) {
            //errors.row_id = 'Row ID should not be less than or more than 10 digits';
        }
        return errors;
    };
    const handlePlantSelectChange = (e) => {
        formData.plant_id = e.target.value;
        //alert(e.target.value);
        if (e.target.value !== null) {
            fetchBlockList(e.target.value)
            fetchRowList(e.target.value)
        }
    }
    const handleBlockSelectChange = (e) => {
        formData.block_id = e.target.value;
        // fetchRowList(formData.plant_id, formData.block_id)
    };
    const handleRowSelectChange = (e) => {
        formData.row_id = e.target.value;
    };
    useEffect(() => {
        fetchPlantList();
        fetchRowList(plantID);
        fetchBlockList(plantID);
    }, [])
    useEffect(() => {
        console.log(plantOption)
    }, [plantOption])
    const fetchPlantList = async () => {
        var userID = sessionStorage.getItem("user_id");
        let response = await AxiosInstance.get("/PlantBlock/GetPlantList?paramid=1&=uid=1&pn=PlantList&dn=PlantList");
        setPlantOption(response.data);
    }
    const fetchRowList = async (pid) => {
        var userID = sessionStorage.getItem("user_id");
        let response = await Axios("/DropDownList/GetRowList?paramid=" + pid + "&=uid=" + userID + "&pn=RowList&dn=RowListByPlantID");
        setRowOption(response.data);
    }
    const fetchBlockList = async (pid) => {
        alert(pid);
        var userID = sessionStorage.getItem("user_id");
        let response = await Axios("/DropDownList/GetBlockList?paramid=" + pid + "&=uid=" + userID + "&pn=BlockList&dn=BlockListByPlantID");
        setBlockOption(response.data);
    }
    return (
        <>
            {hasJWTToken() ? (//&& (role_id === 1 || role_id === 5 || role_id === 4 || role_id === 3 || role_id === 2) 
                <div className="container-ul">
                    <div className="form-container">
                        <h2 className="form-title"><FaIcons.FaRegEdit /> Add New Block Row</h2>
                        <span className="form-message">
                            {formData.message}
                        </span>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <Form.Select name="plant_id" onChange={handlePlantSelectChange}>
                                    {plantOption.map(opt => (
                                        <option value={opt.plant_id}>{opt.plant_name}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div>
                                <Form.Select name="block_id" onChange={handleBlockSelectChange}>
                                    {blockOption.map(opt => (
                                        <option value={opt.block_id}>{opt.block_name}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div>
                                <Form.Select name="row_id" onChange={handleRowSelectChange}>
                                    {rowOption.map(opt => (
                                        <option value={opt.row_id}>{opt.row_name}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div class="row">
                                <div class="col-9"><button className="submit-button" type="submit">Submit</button></div>
                                <div class="col-3"><a className="btndelete" href="#/SearchBlockRows">Search Block Row</a></div>
                            </div>
                        </form>
                    </div>
                </div>
            ) :
                (
                    window.location.href = "#/Login"
                )
            }
        </>
    );
}
export default BlockRows;